import React from 'react';
import { useAppSelector } from '../../../store';

import Tabber from './tabber';

const SectionEvents = () => {
    const { tuttorialIndex } = useAppSelector(state => state.moments);
    return (
        <div className={tuttorialIndex > 0 ? 'c-container-02 active' : 'c-container-02'}>
            <nav className="c-content">
                <Tabber />
            </nav>
        </div>
    );
};

export default SectionEvents;
